








import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    SearchProducts: () => import('@/components/SearchProducts.vue')
  }
})
export default class Search extends Vue {
  created() {
    window.document.title = `${this.$i18n.t('pageTitle.search')} - LDX`
  }
}
